var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirplane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 468,
    height: 468,
    viewBox: "0 0 123.825 123.825",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M-.587-.587h125v125h-125z",
    paintOrder: "fill markers stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c7c7",
    d: "M87.665 62.997l-48.163 9.88 6.227 4.239 3.726 12.346 6.726-5.231 10.273 6.993.007-.009.061.042-.035-.078z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c1c1c",
    d: "M49.704 84.623l11.25-15.599-13.735-3.857-.999 7.518z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d0d0d0",
    d: "M31.809 59.993l60.207-27.425L72.49 83.481z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M31.908 60.031l27.906 1.456L72.59 83.52z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#545454",
    d: "M92.016 32.568l-50.81 32.851 8.498 19.204V70.325z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplane);
export default __webpack_public_path__ + "static/media/airplane.e52c31e4.svg";
export { ForwardRef as ReactComponent };